<template>
  <div>
    
   <components :is="current" @next="next"></components>
  </div>
</template>
<script>
import{ Prepare, Create,IMToken,IMtokenTip } from "./components";
import {mapActions} from 'vuex'
export default {
  name:'createWallet',
  meta:{
    authorization:true
  },
  data(){
    return{
      current:'Prepare',
    };
  },
  components:{
    Prepare,
    Create,
    IMToken,
    IMtokenTip
  },
  methods:{
    ...mapActions('wallet',['getWallets']),
    next(name){
      this.current = name
    }
  },
  async mounted(){
    try{
      await this.getWallets();
      this.$router.push({name:'home'})
    }catch(e){
      console.log(e)
    }
  }
}
</script>